import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';

import { cancel_benefits_path, cancel_feedback_path } from '../../routes.js';
import { STRIPE_PUBLISH_KEY } from '../../src/env';
import { createSetupIntent } from '../../utils/backend-api/stripe';
import { PaymentInfoProps } from '../../utils/backend-api/updatePayment';
import { Spinner } from '../BaseUI';
import PaymentMethod from './PaymentMethod';
import Testimonial from './Testimonial';

const stripePromise = loadStripe(STRIPE_PUBLISH_KEY);

const UpdatePaymentInfo = ({
  billingAmount,
  billingDate,
  creditCardLast4Digits,
  isUserPastDue,
  paymentType,
  stripeCustomerId,
}: PaymentInfoProps) => {
  const cancelAccountPath = isUserPastDue ? cancel_feedback_path() : cancel_benefits_path();
  const [clientSecret, setClientSecret] = useState('');

  useEffect(() => {
    (async () => {
      const { client_secret: clientSecret } = await createSetupIntent({
        stripe_customer_id: stripeCustomerId,
      });
      setClientSecret(clientSecret);
    })();
  }, [stripeCustomerId]);

  return (
    <div className="container" id="update-card">
      <div className="row">
        <div className="col-sm-8 col-sm-offset-2">
          <div className="subscription-info">
            {isUserPastDue ? (
              <div id="resurrect-card">
                <div className="top">
                  <h1 className="title">Re-Enable The Information</h1>
                  <p className="title-sub">
                    Your account is currently disabled. Re-join The Information on your existing
                    plan by updating your payment method.
                  </p>
                </div>
              </div>
            ) : (
              <>
                {billingDate && (
                  <div>
                    <h1 className="title">Subscription Information</h1>
                    <p className="subscription-info-detail">
                      Your next cycle begins on{' '}
                      <span className="subscription-info-detail-value">{billingDate}.</span>
                      You will be charged{' '}
                      <span className="subscription-info-detail-value">{billingAmount}.</span>
                    </p>
                  </div>
                )}
                {paymentType && (
                  <p className="subscription-info-detail">
                    Payment type on file: {paymentType.replace('_', ' ')}
                    {creditCardLast4Digits && (
                      <>
                        , with last 4 digits:{' '}
                        <span className="subscription-info-detail-value">
                          {creditCardLast4Digits}
                        </span>
                      </>
                    )}
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-8 col-sm-offset-2">
          {!isUserPastDue && (
            <div className="top">
              <h1 className="title">Update your payment method</h1>
            </div>
          )}
          {clientSecret ? (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <PaymentMethod />
            </Elements>
          ) : (
            <div className="text-center mt-16 mb-16">
              <Spinner />
            </div>
          )}
          <Testimonial />
          <p className="cancel">
            If you no longer wish to subscribe to The Information you can{' '}
            <a className="cancel-account" href={cancelAccountPath}>
              cancel your account
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default UpdatePaymentInfo;
